import { create } from "zustand";
import { PDA1060_R01Dto, PDA1060_R01SearchParams } from "src/containers/PDA/PDA1060_R01/PDA1060_R01Dto";

export interface PDA1060_R01Store {
  // 상태
  stockList: PDA1060_R01Dto[];
  loading: boolean;
  searchParams: PDA1060_R01SearchParams;

  // UI 표시용 (응답값 저장, 1090과 동일 컬럼)
  displayInfo: {
    itemCd: string;
    itemNm: string;
    itemSpec: string;
    modelNo: string;
    unit: string;
    itemStatus: string;
    warehouseNm: string;
    locationCd: string;
    stockQty: number | null;
    /** 스캔한 LOT 번호 (검색에 사용한 값) */
    lotNo: string;
  };

  // 액션
  setStockList: (stockList: PDA1060_R01Dto[]) => void;
  setLoading: (loading: boolean) => void;
  setSearchParams: (searchParams: PDA1060_R01SearchParams) => void;
  updateSearchParam: (field: keyof PDA1060_R01SearchParams, value: string) => void;
  setDisplayInfo: (info: Partial<PDA1060_R01Store["displayInfo"]>) => void;
  reset: () => void;
}

const initialSearchParams: PDA1060_R01SearchParams = {
  scanValue: "",
  logicCenter: "WMS10",
};

const initialDisplayInfo = {
  itemCd: "",
  itemNm: "",
  itemSpec: "",
  modelNo: "",
  unit: "",
  itemStatus: "",
  warehouseNm: "",
  locationCd: "",
  stockQty: null as number | null,
  lotNo: "",
};

/**
 * PDA1060_R01 (재고조회) 스토어
 * 재고조회 화면의 상태와 액션을 관리
 */
const usePDA1060_R01Store = create<PDA1060_R01Store>((set) => ({
  stockList: [],
  loading: false,
  searchParams: initialSearchParams,
  displayInfo: initialDisplayInfo,

  setStockList: (stockList) => set({ stockList }),

  setLoading: (loading) => set({ loading }),

  setSearchParams: (searchParams) => set({ searchParams }),

  updateSearchParam: (field, value) =>
    set((state) => ({
      searchParams: {
        ...state.searchParams,
        [field]: value,
      },
    })),

  setDisplayInfo: (info) =>
    set((state) => ({
      displayInfo: {
        ...state.displayInfo,
        ...info,
      },
    })),

  reset: () =>
    set({
      stockList: [],
      loading: false,
      searchParams: initialSearchParams,
      displayInfo: initialDisplayInfo,
    }),
}));

export default usePDA1060_R01Store;
